// extracted by mini-css-extract-plugin
export default {"card__global":"CardGlobal_card__global__-kGaE"};